import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { v4 as uuid } from 'uuid';

@Component({
    selector: 'self-employment-type',
    templateUrl: './self-employment-type.component.html',
    styleUrls: ['./self-employment-type.component.scss'],
    standalone: false
})
export class SelfEmploymentTypeComponent implements OnInit {
    /**
     * UUI to identify controls when multiple deployed
     * @type {string}
     * @memberof SelfEmploymentTypeComponent
     */
    instanceId: string;

    /**
     * Control for the radio buttons
     * @type {FormControl}
     * @memberof SelfEmploymentTypeComponent
     */
    radioControlSelfEmploymentType: UntypedFormControl = new UntypedFormControl();

    /**
     * Control for the select list
     * @type {FormControl}
     * @memberof SelfEmploymentTypeComponent
     */
    selectControlSelfEmploymentType: UntypedFormControl = new UntypedFormControl();

    /**
     * FormGroup for the controls
     *
     * @type {FormGroup}
     * @memberof SelfEmploymentTypeComponent
     */
    formSelfEmploymentType: UntypedFormGroup;

    types: Object[] = [
        { value: 1, label: 'Limited company' },
        { value: 2, label: 'Partnership' },
        { value: 3, label: 'Sole trader' },
    ];

    /**
     * Inoming form control containing income type
     * @type {FormControl}
     * @memberof SelfEmploymentTypeComponent
     */
    @Input() selfEmploymentType: UntypedFormControl;

    /**
     * Event emitting the output formcontrol
     * @type {EventEmitter}
     * @memberof SelfEmploymentTypeComponent
     */
    @Output() selfEmploymentTypeChange: EventEmitter<UntypedFormControl> = new EventEmitter<UntypedFormControl>();


    /**
     * Deal with ANOTHER nested select! -_-
     * 
     * @param {any} event 
     * @memberof SelfEmploymentTypeComponent
     */
    onTouchClicked(event) { 
        const radio = this.radioControlSelfEmploymentType;
        const select = this.selectControlSelfEmploymentType;

        if(event === 'radio' && radio.untouched) { 
            this.radioControlSelfEmploymentType.markAsTouched();
            this.selfEmploymentTypeChange.emit(this.radioControlSelfEmploymentType);
        }
        if(event === 'select' && select.untouched) { 
            this.selectControlSelfEmploymentType.markAsTouched();
            this.selfEmploymentTypeChange.emit(this.selectControlSelfEmploymentType);
        }
    }

    /**
     * Creates an instance of SelfEmploymentTypeComponent.
     * @param {FormBuilder} fb
     * @memberof SelfEmploymentTypeComponent
     */
    constructor(private fb: UntypedFormBuilder) {
        this.formSelfEmploymentType = fb.group({
            selectControlSelfEmploymentType: this.selectControlSelfEmploymentType,
            radioControlSelfEmploymentType: this.radioControlSelfEmploymentType,
        });
    }

    /**
     * Initialise component
     * @memberof SelfEmploymentTypeComponent
     */
    ngOnInit() {
        this.instanceId = uuid();
        this.onChanges();
        this.formSelfEmploymentType.get('radioControlSelfEmploymentType').
                                        setValue(this.selfEmploymentType.value);
        this.formSelfEmploymentType.get('selectControlSelfEmploymentType').
                                        setValue(this.selfEmploymentType.value);
    }
    /**
     * Track changes in the form controls
     * @memberof SelfEmploymentTypeComponent
     */
    onChanges(): void {
        this.formSelfEmploymentType.get('radioControlSelfEmploymentType').valueChanges.subscribe((val) => {
            if (this.formSelfEmploymentType.get('selectControlSelfEmploymentType').value !== val) {
                this.formSelfEmploymentType.get('selectControlSelfEmploymentType').setValue(val);
                this.selfEmploymentTypeChange.emit(this.radioControlSelfEmploymentType);
            }
        });
        this.formSelfEmploymentType.get('selectControlSelfEmploymentType').valueChanges.subscribe((val) => {
            if (this.formSelfEmploymentType.get('radioControlSelfEmploymentType').value !== val) {
                this.formSelfEmploymentType.get('radioControlSelfEmploymentType').setValue(val);
                this.selfEmploymentTypeChange.emit(this.selectControlSelfEmploymentType);
            }
        });
    }
}
